// @flow
import cookies from '<drivers>/cookie';
import UAParser from 'ua-parser-js';

const minimumVersions = {
    safari: 9,
    'mobile-safari-mobile': 9,
    chrome: 44,
    'chrome-mobile': 44,
    ie: 11,
    'ie-mobile': 11,
    firefox: 45
};

function getVersion() {
    const uaInfo = new UAParser().getResult();
    let browserType = uaInfo.browser.name.toLowerCase().replace(' ', '-');
    if (uaInfo.device && uaInfo.device.type) {
        browserType += '-' + uaInfo.device.type.toLowerCase();
    }

    return {
        type: browserType,
        version: parseFloat(uaInfo.browser.version)
    };
}

window.browserDetect = function browserDetect(cookieKey, redirectTo) {
    const skipBrowserWarning = cookies.get(cookieKey);

    if (!skipBrowserWarning) {
        const browserVersion = getVersion();
        if (
            minimumVersions[browserVersion.type] &&
            browserVersion.version &&
            browserVersion.version < minimumVersions[browserVersion.type]
        ) {
            document.location = redirectTo;
        }
    }
};



// WEBPACK FOOTER //
// ./src/assets/scripts/browser-detect.js